(function () {
  'use strict';

  function language() {
    var raw = String(document.documentElement.lang || 'en').toLowerCase().replace(/_/g, '-');
    if (raw.indexOf('es') === 0) return 'es';
    if (raw.indexOf('tr') === 0) return 'tr';
    if (raw.indexOf('de') === 0) return 'de';
    if (raw.indexOf('pt') === 0) return 'pt';
    return 'en';
  }

  var COPY = {
    en: { browse: 'Browse', opening: 'Opening the PDF in a new tab… If nothing happens, check your browser downloads.' },
    es: { browse: 'Ver guía', opening: 'Abriendo el PDF en una pestaña nueva… Si no ocurre nada, revisa las descargas del navegador.' },
    tr: { browse: 'Rehberi aç', opening: 'PDF yeni bir sekmede açılıyor… Açılmazsa tarayıcı indirmelerini kontrol edin.' },
    de: { browse: 'Ratgeber öffnen', opening: 'Das PDF wird in einem neuen Tab geöffnet… Prüfe andernfalls die Browser-Downloads.' },
    pt: { browse: 'Ver guia', opening: 'A abrir o PDF num novo separador… Se nada acontecer, verifique os downloads do navegador.' }
  };

  function enhanceBlogBadge(copy) {
    var badge = document.querySelector('.m-article__blog');
    if (!badge || badge.querySelector('.m-article__blog-action')) return;
    var category = badge.textContent.trim();
    var action = document.createElement('span');
    action.className = 'm-article__blog-action';
    action.setAttribute('aria-hidden', 'true');
    action.textContent = copy.browse + ' →';
    badge.appendChild(action);
    badge.setAttribute('aria-label', category + ': ' + copy.browse);
  }

  function isPrintableArticle() {
    return /printable-tarot|tarot-cards-printable|cartas-de-tarot-imprimibles|cartas-de-tarot-para-imprimir|tarotkarten.*druck|tarot-kartlari.*yazdir/i.test(location.pathname);
  }

  function findDownloadHeading(content) {
    var headings = content.querySelectorAll('h2, h3');
    for (var i = 0; i < headings.length; i += 1) {
      if (/download|descarg|baix|herunterlad|indir/i.test(headings[i].textContent || '')) return headings[i];
    }
    return content.querySelector('#toc-3');
  }

  function isDeckListItem(text) {
    return /^(?:22\s+(?:Major Arcana|Arcanos Mayores|Arcanos Maiores|Große Arkana|Büyük Arkana)|14\s+(?:Wands|Cups|Swords|Pentacles|Bastos|Copas|Espadas|Oros|Paus|Taças|Ouros|Stäbe|Kelche|Schwerter|Münzen|Değnek|Kupa|Kılıç|Tılsım))(?:\s|$)/i.test(text);
  }

  function linkPrintableRows(content, heading) {
    if (!heading) return;
    if (!heading.id) heading.id = 'printable-downloads';
    var target = '#' + heading.id;
    content.querySelectorAll('li').forEach(function (item) {
      if (item.querySelector('a') || !isDeckListItem(item.textContent.trim())) return;
      var link = document.createElement('a');
      link.href = target;
      link.className = 'm-printable-jump';
      while (item.firstChild) link.appendChild(item.firstChild);
      item.appendChild(link);
    });
  }

  function addDownloadFeedback(content, copy, startAt) {
    var counter = startAt;
    content.querySelectorAll('a[href]').forEach(function (link) {
      if (!/\.pdf(?:$|[?#])/i.test(link.href)) return;
      counter += 1;
      var status = document.createElement('span');
      var statusId = 'pdf-download-status-' + counter;
      status.id = statusId;
      status.className = 'm-pdf-download-status';
      status.hidden = true;
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      link.classList.add('m-pdf-download-link');
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-describedby', statusId);
      link.insertAdjacentElement('afterend', status);
      link.addEventListener('click', function () {
        status.textContent = copy.opening;
        status.hidden = false;
        window.setTimeout(function () { status.hidden = true; }, 8000);
      });
    });
    return counter;
  }

  function init() {
    var copy = COPY[language()] || COPY.en;
    enhanceBlogBadge(copy);
    if (!isPrintableArticle()) return;
    var contents = document.querySelectorAll('.m-article__content.rte');
    if (!contents.length) return;
    var downloadCounter = 0;
    contents.forEach(function (content) {
      linkPrintableRows(content, findDownloadHeading(content));
      downloadCounter = addDownloadFeedback(content, copy, downloadCounter);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
